<template>
	<div class="addEdit-block">
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
			<el-form-item label="月份" prop="yuefen">
				<el-select v-if="type!='info'" v-model="ruleForm.yuefen" placeholder="请选择月份" :disabled="ro.yuefen" style="width:100%">
					<el-option v-for="(item,index) in yuefenOptions" :key="index" :label="item" :value="item"></el-option>
				</el-select>
				<el-input v-else v-model="ruleForm.yuefen" placeholder="月份" readonly></el-input>
			</el-form-item>
			<el-form-item label="工号" prop="gonghao">
				<el-select v-if="type!='info'" @change="gonghaoChange" v-model="ruleForm.gonghao" placeholder="请选择工号" :disabled="ro.gonghao" style="width:100%">
					<el-option v-for="(item,index) in gonghaoOptions" :key="index" :label="item" :value="item"></el-option>
				</el-select>
				<el-input v-else v-model="ruleForm.gonghao" placeholder="工号" readonly></el-input>
			</el-form-item>
			<el-form-item label="姓名" prop="xingming">
				<el-input v-model="ruleForm.xingming" placeholder="姓名" clearable :readonly="true"></el-input>
			</el-form-item>
			
			<el-divider>养老保险</el-divider>
			<el-form-item label="个人缴纳" prop="yanglaoGeren">
				<el-input-number v-model="ruleForm.yanglaoGeren" placeholder="养老保险（个人）" :precision="2" :readonly="ro.yanglaoGeren"></el-input-number>
			</el-form-item>
			<el-form-item label="公司缴纳" prop="yanglaoGongsi">
				<el-input-number v-model="ruleForm.yanglaoGongsi" placeholder="养老保险（公司）" :precision="2" :readonly="ro.yanglaoGongsi"></el-input-number>
			</el-form-item>
			
			<el-divider>医疗保险</el-divider>
			<el-form-item label="个人缴纳" prop="yiliaoGeren">
				<el-input-number v-model="ruleForm.yiliaoGeren" placeholder="医疗保险（个人）" :precision="2" :readonly="ro.yiliaoGeren"></el-input-number>
			</el-form-item>
			<el-form-item label="公司缴纳" prop="yiliaoGongsi">
				<el-input-number v-model="ruleForm.yiliaoGongsi" placeholder="医疗保险（公司）" :precision="2" :readonly="ro.yiliaoGongsi"></el-input-number>
			</el-form-item>
			
			<el-divider>失业保险</el-divider>
			<el-form-item label="个人缴纳" prop="shiyeGeren">
				<el-input-number v-model="ruleForm.shiyeGeren" placeholder="失业保险（个人）" :precision="2" :readonly="ro.shiyeGeren"></el-input-number>
			</el-form-item>
			<el-form-item label="公司缴纳" prop="shiyeGongsi">
				<el-input-number v-model="ruleForm.shiyeGongsi" placeholder="失业保险（公司）" :precision="2" :readonly="ro.shiyeGongsi"></el-input-number>
			</el-form-item>
			
			<el-divider>其他保险</el-divider>
			<el-form-item label="工伤保险（公司）" prop="gongshangGongsi">
				<el-input-number v-model="ruleForm.gongshangGongsi" placeholder="工伤保险（公司）" :precision="2" :readonly="ro.gongshangGongsi"></el-input-number>
			</el-form-item>
			<el-form-item label="生育保险（公司）" prop="shengyuGongsi">
				<el-input-number v-model="ruleForm.shengyuGongsi" placeholder="生育保险（公司）" :precision="2" :readonly="ro.shengyuGongsi"></el-input-number>
			</el-form-item>
			
			<el-divider>住房公积金</el-divider>
			<el-form-item label="个人缴纳" prop="gongjijinGeren">
				<el-input-number v-model="ruleForm.gongjijinGeren" placeholder="住房公积金（个人）" :precision="2" :readonly="ro.gongjijinGeren"></el-input-number>
			</el-form-item>
			<el-form-item label="公司缴纳" prop="gongjijinGongsi">
				<el-input-number v-model="ruleForm.gongjijinGongsi" placeholder="住房公积金（公司）" :precision="2" :readonly="ro.gongjijinGongsi"></el-input-number>
			</el-form-item>
			
			<el-divider>合计</el-divider>
			<el-form-item label="个人合计" prop="gerenHeji">
				<el-input v-if="type!='info'" v-model="gerenHejiComputed" placeholder="个人合计（自动计算）" readonly style="width:100%"></el-input>
				<el-input v-else v-model="ruleForm.gerenHeji" placeholder="个人合计" readonly style="width:100%"></el-input>
			</el-form-item>
			<el-form-item label="公司合计" prop="gongsiHeji">
				<el-input v-if="type!='info'" v-model="gongsiHejiComputed" placeholder="公司合计（自动计算）" readonly style="width:100%"></el-input>
				<el-input v-else v-model="ruleForm.gongsiHeji" placeholder="公司合计" readonly style="width:100%"></el-input>
			</el-form-item>
			
			<el-form-item label="缴纳日期" prop="jiaonaRiqi">
				<el-date-picker v-model="ruleForm.jiaonaRiqi" type="date" placeholder="选择缴纳日期" value-format="yyyy-MM-dd" :readonly="ro.jiaonaRiqi"></el-date-picker>
			</el-form-item>
			<el-form-item label="备注" prop="beizhu">
				<el-input v-model="ruleForm.beizhu" type="textarea" placeholder="备注" :readonly="ro.beizhu"></el-input>
			</el-form-item>

			<el-form-item v-if="!ro.showSubmit">
				<el-button type="primary" @click="submitForm()">提交</el-button>
				<el-button @click="back()">取消</el-button>
			</el-form-item>
			<el-form-item v-else>
				<el-button @click="back()">返回</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
	data() {
		return {
			id: '',
			type: '',
			ro: {
				yuefen: false,
				gonghao: false,
				xingming: false,
				yanglaoGeren: false,
				yanglaoGongsi: false,
				yiliaoGeren: false,
				yiliaoGongsi: false,
				shiyeGeren: false,
				shiyeGongsi: false,
				gongshangGongsi: false,
				shengyuGongsi: false,
				gongjijinGeren: false,
				gongjijinGongsi: false,
				gerenHeji: false,
				gongsiHeji: false,
				jiaonaRiqi: false,
				beizhu: false,
				showSubmit: false
			},
			ruleForm: {
				yuefen: '',
				gonghao: '',
				xingming: '',
				yanglaoGeren: 0,
				yanglaoGongsi: 0,
				yiliaoGeren: 0,
				yiliaoGongsi: 0,
				shiyeGeren: 0,
				shiyeGongsi: 0,
				gongshangGongsi: 0,
				shengyuGongsi: 0,
				gongjijinGeren: 0,
				gongjijinGongsi: 0,
				gerenHeji: 0,
				gongsiHeji: 0,
				jiaonaRiqi: '',
				beizhu: ''
			},
			yuefenOptions: [],
			gonghaoOptions: [],
			rules: {}
		}
	},
	props: ["parent"],
	computed: {
		// 个人合计自动计算
		gerenHejiComputed: {
			get: function() {
				let yanglao = parseFloat(this.ruleForm.yanglaoGeren === '' || this.ruleForm.yanglaoGeren === null ? 0 : this.ruleForm.yanglaoGeren);
				let yiliao = parseFloat(this.ruleForm.yiliaoGeren === '' || this.ruleForm.yiliaoGeren === null ? 0 : this.ruleForm.yiliaoGeren);
				let shiye = parseFloat(this.ruleForm.shiyeGeren === '' || this.ruleForm.shiyeGeren === null ? 0 : this.ruleForm.shiyeGeren);
				let gongjijin = parseFloat(this.ruleForm.gongjijinGeren === '' || this.ruleForm.gongjijinGeren === null ? 0 : this.ruleForm.gongjijinGeren);
				let total = yanglao + yiliao + shiye + gongjijin;
				return total.toFixed(2);
			}
		},
		// 公司合计自动计算
		gongsiHejiComputed: {
			get: function() {
				let yanglao = parseFloat(this.ruleForm.yanglaoGongsi === '' || this.ruleForm.yanglaoGongsi === null ? 0 : this.ruleForm.yanglaoGongsi);
				let yiliao = parseFloat(this.ruleForm.yiliaoGongsi === '' || this.ruleForm.yiliaoGongsi === null ? 0 : this.ruleForm.yiliaoGongsi);
				let shiye = parseFloat(this.ruleForm.shiyeGongsi === '' || this.ruleForm.shiyeGongsi === null ? 0 : this.ruleForm.shiyeGongsi);
				let gongshang = parseFloat(this.ruleForm.gongshangGongsi === '' || this.ruleForm.gongshangGongsi === null ? 0 : this.ruleForm.gongshangGongsi);
				let shengyu = parseFloat(this.ruleForm.shengyuGongsi === '' || this.ruleForm.shengyuGongsi === null ? 0 : this.ruleForm.shengyuGongsi);
				let gongjijin = parseFloat(this.ruleForm.gongjijinGongsi === '' || this.ruleForm.gongjijinGongsi === null ? 0 : this.ruleForm.gongjijinGongsi);
				let total = yanglao + yiliao + shiye + gongshang + shengyu + gongjijin;
				return total.toFixed(2);
			}
		}
	},
	created() {},
	mounted() {
		// 初始化月份选项
		this.yuefenOptions = "一月,二月,三月,四月,五月,六月,七月,八月,九月,十月,十一月,十二月".split(',')
		// 获取工号选项
		this.$http({
			url: `option/yuangong/gonghao`,
			method: "get"
		}).then(({ data }) => {
			if (data && data.code === 0) {
				this.gonghaoOptions = data.data;
			} else {
				this.$message.error(data.msg);
			}
		});
	},
	methods: {
		// 工号变更事件
		gonghaoChange() {
			this.$http({
				url: `follow/yuangong/gonghao?columnValue=` + this.ruleForm.gonghao,
				method: "get"
			}).then(({ data }) => {
				if (data && data.code === 0) {
					if(data.data.xingming){
						this.ruleForm.xingming = data.data.xingming
					}
				} else {
					this.$message.error(data.msg);
				}
			});
		},
		init(id, type) {
			this.id = id || 0;
			this.type = type || '';
			
			if (this.type == 'info') {
				this.ro.showSubmit = true
				for (let key in this.ro) {
					this.ro[key] = true
				}
			}
			
			if (this.id) {
				this.getInfo()
			}
		},
	// 获取详情
	getInfo() {
		this.$http({
			url: `yuangongshebao/info/${this.id}`,
			method: "get"
		}).then(({ data }) => {
				if (data && data.code === 0) {
					this.ruleForm = data.data
				}
			})
		},
		// 提交
		submitForm() {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
				// 将计算的合计值赋给表单
				this.ruleForm.gerenHeji = parseFloat(this.gerenHejiComputed);
				this.ruleForm.gongsiHeji = parseFloat(this.gongsiHejiComputed);
				
				this.$http({
					url: `yuangongshebao/${!this.id ? 'save' : 'update'}`,
					method: "post",
					data: this.ruleForm
				}).then(({ data }) => {
						if (data && data.code === 0) {
							this.$message({
								message: '操作成功',
								type: 'success',
								duration: 1500,
								onClose: () => {
									this.parent.showFlag = true;
									this.parent.getDataList();
								}
							})
						} else {
							this.$message.error(data.msg)
						}
					})
				}
			})
		},
		back() {
			this.parent.showFlag = true;
		}
	}
}
</script>

<style lang="scss" scoped>
.addEdit-block {
	padding: 20px;
}

.el-divider {
	margin: 30px 0;
}
</style>

